import React from "react";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import LightTooltip from "../../../Components/LightTooltip";

export default function OptionButton({ handleDelete }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <LightTooltip title={t("common.buttons.more")}>
        <IconButton
          aria-controls="option-menu"
          aria-haspopup="true"
          onClick={handleClick}
          size="small"
          style={{ padding: 8 }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </LightTooltip>
      <Menu
        id="option-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleDelete}>
          {t("timeline.buttons.deleteNote")}
        </MenuItem>
      </Menu>
    </div>
  );
}
